import React from 'react'
import './content-ty-page.scss'
import logo from '../../../shared/assets/images/logo_black.svg'
import Breadcrumb from '../../../shared/components/atoms/breadcrumb/breadcrumb';
import okIcon from '../../../shared/assets/images/icons/ok.svg'
import Button from '../../../shared/components/atoms/button/button'
import { useStaticQuery, graphql } from "gatsby"
import siteUrl from '../../../shared/utils/siteUrl';

const ContentTyPage = () => {
    const { contentfulInformacionGeneral } = useStaticQuery(graphql`
        {
            contentfulInformacionGeneral {
                bannerThankYouPage {
                file {
                    url
                }
                description
                }
                bannerThankYouPageMobile {
                    file {
                        url
                    }
                }
            }
        }
    `)

    const { bannerThankYouPage, bannerThankYouPageMobile } = contentfulInformacionGeneral

    const handleClick = () => {
        window.location.href = siteUrl + '/bienes-en-venta/'
    }

    return (
        <div className="o-content-contact-ty">
            <div className="o-content-contact-ty-top">
                <Breadcrumb />
                <div className="o-header-bottom-logo">
                    <img
                        src={logo}
                        className="o-header-bottom-logo-image"
                        alt="Logo principal BAM"
                    />
                </div>
            </div>
            <div className="o-content-ty-fullimage">
                <img
                    className="o-content-ty-fullimage-image"
                    src={bannerThankYouPageMobile.file.url}
                    alt={"Imagen de fondo agradecimiento"}
                />
            </div>
            <div className="o-content-contact-ty-body">
                <div className="o-content-contact-ty-body-banner">
                    <img
                        src={bannerThankYouPage.file.url}
                        alt="Banner página de agradecimiento"
                        className="o-content-contact-ty-body-banner-img"
                    />
                </div>
                <div className="o-content-contact-ty-body-description">
                    <img
                        src={okIcon}
                        alt={'Icono de check'}
                        className="o-content-contact-ty-body-description-icon"
                    />
                    <h5>Hemos recibido tu mensaje. En breve uno de nuestros asesores se pondrá en contacto contigo.</h5>
                    <br></br>
                    <br></br>
                    <div className="o-ty-button-container">
                        <Button
                            title='VOLVER A BIENES'
                            className='full'
                            onClick={handleClick}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ContentTyPage
